import React, { useEffect } from 'react';

import './Message.css';

export function Message({
  text,
  type = 'error',
  onClosed,
  closeTimeout = 5000,
}) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClosed();
    }, closeTimeout);

    return () => {
      clearTimeout(timer);
    };
  }, [closeTimeout]);

  return (
    <div
      className="Message"
      style={{
        backgroundColor: 'hsla(var(--accent), .3)',
        borderColor: 'var(--accent-color)',
      }}
    >
      <p
        style={{
          color: 'var(--accent-color)',
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        {text}
      </p>
      <button className="Message__close-button reset-button" onClick={onClosed}>
        &times;
      </button>
    </div>
  );
}
